import React from 'react';
import ReactToolTip from 'react-tooltip';
import { League } from '../models/League';

class LeaguePlayerComponent extends React.PureComponent {
	static generationIds = 1;
	static defaultProps = {
		requirementsNecessaryToBeDisplayed: true,
		hidePoints: false,
		hideDivision: false,
		showBlankDivisionForUnranked: false,
		extraClasses: '',
		title: null,
		showRawPoints: false,
		showUnrankedForMissingLeague: false,
	};

	constructor(props) {
		super(props);
		const { showRawPoints } = this.props;
		this.uniqueId = `LeaguePlayerComponent-${LeaguePlayerComponent.generationIds++}`;
		this.state = {};
		// this.leagueClick = showRawPoints ? (e) => {
		// 	e.stopPropagation();
		// 	this.setState((state) => ({
		// 		selected: !state.selected
		// 	}));
		// } : null;
	}

	render() {
		const {
			showRawPoints,
			league,
			hidePoints,
			hideDivision,
			requirementsNecessaryToBeDisplayed,
			extraClasses,
			title,
			showBlankDivisionForUnranked,
			showUnrankedForMissingLeague,
		} = this.props;
		const { selected } = this.state;


		let leagueDisplayed = null;
		if(showUnrankedForMissingLeague && !league) {
			leagueDisplayed = League.createUnranked();
		}
		else {
			leagueDisplayed = league;
		}

		if(!leagueDisplayed) {
			return null;
		}
		if(requirementsNecessaryToBeDisplayed && !leagueDisplayed.meetsRankedRequirements()) {
			return null;
		}

		let divisionToShow = '';
		if(showBlankDivisionForUnranked && leagueDisplayed.isUnranked()) {
			divisionToShow = '---';
		}
		else {
			divisionToShow = leagueDisplayed.division;
		}

		let titleToShow = null;
		if(title) {
			titleToShow = title;
		}
		else if(leagueDisplayed.name) {
			titleToShow = `${leagueDisplayed.name} ${leagueDisplayed.points === undefined ? '' : leagueDisplayed.points}`;
		}
		else {
			titleToShow = 'Unranked';
		}
		const toolTipProps = {};
		if(titleToShow) {
			toolTipProps['data-tip'] = true;
			toolTipProps['data-for'] = this.uniqueId;
		}
		return (
			<React.Fragment>
				<span
					onClick={this.leagueClick}
					className={`league has_league show_image ${selected ? 'selected' : ''} ${extraClasses} ${leagueDisplayed.getUnrankedClassName()}`}
					{...toolTipProps}
				>
					<span className='leagued'>
							<img src={leagueDisplayed.image_url} className='league_icon' />
							<span className='name'>{leagueDisplayed.name}</span>
						{!hideDivision &&
						<span className='division'>{divisionToShow}</span>
						}
						{!hidePoints &&
						<span className='points'>{leagueDisplayed.points}</span>
						}
						{showRawPoints && leagueDisplayed.stats_serialized && leagueDisplayed.stats_serialized.rating &&
						<div className='raw_points'>{leagueDisplayed.stats_serialized.rating}</div>
						}
					</span>
				</span>
				{!!titleToShow &&
				<ReactToolTip
					id={this.uniqueId}
					type='dark'
					effect='solid'
				>
					{titleToShow}
				</ReactToolTip>
				}
			</React.Fragment>
		);
	}
}

export { LeaguePlayerComponent };